import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon, HomeIcon } from '@heroicons/react/24/outline';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <ExclamationTriangleIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h1 className="mt-2 text-4xl font-bold text-gray-900">404</h1>
        <h2 className="mt-2 text-lg font-medium text-gray-900">Page not found</h2>
        <p className="mt-1 text-sm text-gray-500">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <div className="mt-6">
          <Link
            to="/dashboard"
            className="btn-primary flex items-center space-x-2 mx-auto w-fit"
          >
            <HomeIcon className="w-4 h-4" />
            <span>Go back home</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
